import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\GetScreenConfigLastDossierController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigLastDossierController.php
* @route '/api/screen-config/get-last-dossier'
*/
const GetScreenConfigLastDossierController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenConfigLastDossierController.url(options),
    method: 'get',
})

GetScreenConfigLastDossierController.definition = {
    methods: ["get","head"],
    url: '/api/screen-config/get-last-dossier',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Screen\GetScreenConfigLastDossierController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigLastDossierController.php
* @route '/api/screen-config/get-last-dossier'
*/
GetScreenConfigLastDossierController.url = (options?: RouteQueryOptions) => {
    return GetScreenConfigLastDossierController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\GetScreenConfigLastDossierController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigLastDossierController.php
* @route '/api/screen-config/get-last-dossier'
*/
GetScreenConfigLastDossierController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenConfigLastDossierController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Screen\GetScreenConfigLastDossierController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigLastDossierController.php
* @route '/api/screen-config/get-last-dossier'
*/
GetScreenConfigLastDossierController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetScreenConfigLastDossierController.url(options),
    method: 'head',
})

export default GetScreenConfigLastDossierController